// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '7119c807-55e2-4647-ad1a-345b86b1c3bf',
      type: 'Sprite',
      runtimeType: null,
      name: 'avatarSprite',
      className: '',
      x: -40,
      y: -87,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '88fe6c2f-fd2b-4be3-9cc8-543ac4d9e96c',
      type: 'Sprite',
      runtimeType: null,
      name: 'frame',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Friends_Leaderboard_Frame',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '928dc8f8-806f-4de9-bf1f-776a5111c357',
      type: 'Text',
      runtimeType: null,
      name: 'nameText',
      className: '',
      x: 0,
      y: 23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Maria',
      localize: false,
      maxWidth: 118,
      maxHeight: 53,
      maxFontSize: 0,
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x761f00',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '0x761f00',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '2b203114-0d38-4c1a-8e40-8a665b3be9cf',
      type: 'Text',
      runtimeType: null,
      name: 'lvlLabel',
      className: '',
      x: -14,
      y: 65,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lvl',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 16,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'white',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 2,
        dropShadowColor: '0x000000',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'c24cbe66-bcbc-4602-b42d-1a3482c4a423',
      type: 'Text',
      runtimeType: null,
      name: 'lvlText',
      className: '',
      x: 16,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '20',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'white',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 2,
        dropShadowColor: '0x000000',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class EnemyLeaderboardEntryLayout {
  static raw = raw;
  root: Container;
  avatarSprite: Sprite;
  frame: Sprite;
  nameText: Text;
  lvlLabel: Text;
  lvlText: Text;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      avatarSprite: typeof raw['list'][1];
      frame: typeof raw['list'][2];
      nameText: typeof raw['list'][3];
      lvlLabel: typeof raw['list'][4];
      lvlText: typeof raw['list'][5];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
